import { z } from "zod";

export const timesheetSchema = z.object({
  distribution_url: z.string().nullish(),
});

export type TimesheetResponse = z.infer<typeof timesheetSchema>;
